var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isList
    ? _c(
        "transition",
        {
          attrs: { mode: "out-in" },
          on: {
            "before-enter": _vm.beforeEnter,
            enter: _vm.enter,
            "after-enter": _vm.afterEnter,
            "after-leave": _vm.afterLeave,
            leave: _vm.leave,
            "before-leave": _vm.beforeLeave
          }
        },
        [_vm._t("default")],
        2
      )
    : _c(
        "transition-group",
        {
          attrs: { mode: "out-in" },
          on: {
            "before-enter": _vm.beforeEnter,
            enter: _vm.enter,
            "after-enter": _vm.afterEnter,
            "after-leave": _vm.afterLeave,
            leave: _vm.leave,
            "before-leave": _vm.beforeLeave
          }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }